<template>
    <ReactPage>
      <user-task-transaction-report-page></user-task-transaction-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "UserTaskTransactionReport",
    components: {
      ReactPage
    }
  }
  </script>